// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  align-items: flex-start;
}
:host > * + * {
  margin-left: 12px;
}
@media (max-width: 768px) {
  :host .quarter {
    width: 115px;
  }
  :host .type {
    width: 72px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/map/map-controls/map-controls.component.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,uBAAA;AADF;AAGE;EACE,iBAAA;AADJ;AAGE;EACE;IACE,YAAA;EADJ;EAGE;IACE,WAAA;EADJ;AACF","sourcesContent":["@import 'theme';\n\n:host {\n  display: flex;\n  align-items: flex-start;\n\n  & > * + * {\n    margin-left: 12px;\n  }\n  @media (max-width: $mobileBreakpoint) {\n    .quarter {\n      width: 115px;\n    }\n    .type {\n      width: 72px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
